<template>
  <div>
    <div class="has-bg-white is-border is-padding-bottom-xsmall is-margin-bottom-large"
         v-if="(p.pictures && p.pictures.length) || (p.descriptions && p.descriptions.length)">
      <div class="columns is-gapless is-margin-top" v-if="p.pictures && p.pictures.length > 0">
        <div class="column is-12 is-relative">
          <swiper ref="awesomeSwiper" :options="swiperOption" id="mySwiper"
                  class="swiper-container-pagination-top"
                  :class="{'swiper-slide-to-clicked-slide': swiperOption.slideToClickedSlide}"
                  @slideChangeTransitionEnd="slideChangeTransitionEnd"
                  @slideChange="slideChange">
            <div class="swiper-pagination swiper-pagination-bullet--dashed" slot="pagination"
                 v-if="p.pictures && p.pictures.length > 1"></div>
            <swiper-slide v-for="(p, idx) in p.pictures" :key="idx">
              <img :src="p.cloudinary_id | cloudinary({aspect_ratio: '16:9', crop: 'fill', quality: 70})">
            </swiper-slide>
            <!-- <template v-for="(v, idx) in p.videos">
              <div :key="'vid' + idx" class="swiper-slide swiper-slide--video" :id="'slideVideo' + v.video_id">
                <video-external :video='v' :currentSlide='currentSlide'
                                :id="'slideVideo' + v.video_id"></video-external>
              </div>
            </template> -->
          </swiper>
          <div class="field is-grouped swiper-btns-video has-bg-light"
               v-if="p.videos && p.videos.length > 0 && hideBtnsVideo === false"
               style="">
            <div v-for="(v, idx) in p.videos" :key="idx" class="control">
              <button v-if="idx >= 0"
                      class="button is-light is-border is-radiusless"
                      @click="toggleVideo(v)">
                <div
                  class="has-bg-primary has-text-white is-padding-left-xxsmall is-padding-right-xxsmall is-margin-right-xxsmall">
                  <span class="is-size-5"><i class="fas fa-video fa-lg"></i></span>
                </div>
                <span class="is-size-6 is-transform-none">Vidéo de présentation ({{(idx + 1)}})</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="columns is-centered is-margin-top is-margin-bottom is-gapless"
           v-if="p.descriptions && p.descriptions.length"
           v-for="(d, i) in p.descriptions"
           :key="i">
        <div class="column content is-9 ql-editor">
          <h2><strong>{{d.title}}</strong></h2>
          <p v-html="d.text"></p>
        </div>
      </div>
      <div class="columns is-centered is-margin-top is-margin-bottom is-gapless" v-else>
        <div class="column content is-9">
          <p>Aucune description.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import VideoExternal from '../../utils/VideoExternal'

  export default {
    name: 'ProgramDescription',
    components: {
      swiperSlide,
      swiper,
      VideoExternal
    },
    props: {
      program: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        videosInjected: [],
        hideBtnsVideo: false,
        pauseVideo: false,
        nbrImg: null,
        currentSlide: null
      }
    },
    computed: {
      p () {
        return this.program
      },
      swiper () {
        return this.$refs.awesomeSwiper.swiper
      },
      swiperOption () {
        // autoHeight: false,
        let options = {
          spaceBetween: 16,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          slidesPerView: 1.10,
          centeredSlides: true,
          slideToClickedSlide: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
          }
        }
        return options
      }
    },
    methods: {
      slideChange () {
        this.$nextTick(() => {
          let current = document.querySelector('.swiper-slide-active')
          this.currentSlide = current.id
        })
      },
      toggleVideo (v) {
        let params = {
          source: v
        }
        this.$store.commit('setModal', {mode: 'VIDEO_PREVIEW', params})
        // bus.$emit(EVENTS.OPEN_MODAL, { mode: 'VIDEO_PREVIEW', params })
      },
      // injectVideo (v) {
      //   let slideNumber
      //   let slide = document.querySelector('#mySwiper .swiper-slide#slideVideo' + v.video_id)
      //   slideNumber = 0
      //   while ((slide = slide.previousSibling) != null) {
      //     slideNumber++
      //   }
      //   slideNumber = slideNumber - 2 // pour retourner a la bonne slide
      //   this.swiper.slideTo(slideNumber) // on va au slide injecté
      // },
      slideChangeTransitionEnd () {
        // On cache les btn vidéos sur un slide video
        /* let el = document.querySelector('#mySwiper .swiper-slide--video.swiper-slide-active')
        if (el === undefined || el === null || el === false) {
          this.hideBtnsVideo = false
        } else {
          this.hideBtnsVideo = true
        } */
      }
    },
    created () {
      this.nbrImg = this.program.pictures.length
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/program/Tabs/ProgramDescription.vue